import React from "react";
import { useDispatch, useSelector } from "react-redux";
import BasicModalContent from "@bitComponents/unifiedComponents/BasicModalContent";

import OTPRequestPin from "../otpComponents/OTPRequestPin";

import { STRING_KEYS } from "../../../localizedStrings";
import "./otpModalContent.scss";
import { commonActions } from "../../../reducers/common";

const OTPModalContent = ({ taggingInfo, phoneNumber, closeModal }) => {
  const dispatch = useDispatch();
  const { localizedStrings } = useSelector((state) => state.localizedStrings);
  const {
    incorrectValidationPin,
    validationPinExpired,
    pinValidationInProgress,
  } = useSelector((state) => state.uiNeeds.register);

  const handleRequestPin = () => {
    dispatch(commonActions.registerShopper({ requestNewPin: true }));
  };

  const handleValidatePinClicked = (pin) => {
    dispatch(commonActions.validateShopper(pin));
  };

  return (
    <BasicModalContent
      title={localizedStrings[STRING_KEYS.registerPersonalData.otpModal.title]}
      taggingInfo={taggingInfo}
      hideCloseIcon
      hideAdviceIcon
      className="otpModalContent"
    >
      <OTPRequestPin
        taggingInfo={taggingInfo}
        requestedPinLine={phoneNumber}
        handleValidatePinClicked={handleValidatePinClicked}
        handleRequestPin={handleRequestPin}
        pinValidationStatus={{
          validatePinLoading: pinValidationInProgress,
          validatePinMismatch: incorrectValidationPin,
          validationPinExpired,
        }}
      />
    </BasicModalContent>
  );
};

export default OTPModalContent;
